import { useEffect, useRef } from 'react';

import { trackPageView } from 'configurations/analytics-manager';

export const useTrackPageView = (page, title) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Clear previous timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Track page view after 3 seconds
    timeoutRef.current = setTimeout(() => {
      trackPageView(page, title);
    }, 3000);

    // Cleanup on unmount or when page/title changes
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [page, title]);
};
